import React, { useState } from 'react'
import { Box, Button, Container, Grid, Paper, TextField, Typography } from '@mui/material';
import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { login, handleLogin } from '../../redux/AuthSlice';
import { Link, useNavigate } from 'react-router-dom';
function Login() {
    const [loginData, setLoginData] = useState({
        email: "",
        password: "",
    });
    const [error, setError] = useState(null)
    const { isLoggedIn } = useSelector((state) => state.authKey);
    const navigation = useNavigate();
    const dispatch = useDispatch();

    const loginMutation = useMutation({
        mutationFn: (data) => dispatch(login(data)),
        onSuccess: (data) => {
            if (data?.payload?.token) {
                localStorage.setItem("token", data?.payload?.token)
                localStorage.setItem("name", data?.payload?.data.first_name)
                localStorage.setItem("email", data?.payload?.data.email);
                dispatch(handleLogin())
                navigation("/home");

            } else {
                setError(data?.payload)
            }

        },
        onError: (err) => {
            console.log("Error", err);
        },
    });
    const handleSubmit = (e) => {
        e.preventDefault();
        loginMutation.mutate(loginData)
    }
    console.log(isLoggedIn);

    if (isLoggedIn) {
        return (
            <>
                <Typography variant='h2' style={{ marginTop: 50, marginBottom: 25, fontWeight: "bold", textAlign: "center" }}>You are already logged in.</Typography>
                <Button
                    onClick={() => navigation("/home")}
                    variant="contained"
                    color="primary"

                    sx={{ py: 1.5, mt: 2, fontSize: '16px', fontWeight: 'bold', margin:"auto" }}
                >
                    Go to Home
                </Button>
            </>
        )
    }
    return (
        <>
            <Container maxWidth="md">

                <Typography variant='h3' style={{ marginTop: 50, marginBottom: 25, fontWeight: "bold", textAlign: "center" }} sx={{ fontSize: { xs: '26px', sm: '30px', md: '40px' } }}>Log in Now</Typography>
                <Box component={Paper} style={{ padding: '10px 25px', background: "whitesmoke" }} >


                    <Box component="form" onSubmit={handleSubmit} >
                        <Grid container spacing={2} style={{ marginTop: 10, alignItems: "center", justifyContent: "center" }}>
                            <Grid item md={6} >
                                <Box
                                    component="img"
                                    sx={{
                                        width: '100%',
                                        objectFit: 'cover',
                                        borderRadius: 2,
                                    }}
                                    alt="Example Image"
                                    src="assets/image/login.png"
                                />
                            </Grid>
                            <Grid item md={6} >
                                <Typography className="label">Email</Typography>
                                <TextField
                                    value={loginData.email}
                                    onChange={(e) => setLoginData({ ...loginData, email: e.target.value })}
                                    fullWidth
                                    variant="outlined"
                                    required
                                    style={{ marginBottom: 20 }}
                                />
                                <Typography className="label">Password</Typography>
                                <TextField
                                    value={loginData.password}
                                    onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
                                    fullWidth
                                    type='password'
                                    variant="outlined"
                                    required
                                    style={{ marginBottom: 20 }}
                                />
                                <Button
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    type='submit'
                                    disabled={loginMutation.isLoading}
                                    sx={{ py: 1.5, mt: 2, fontSize: '16px', fontWeight: 'bold' }}
                                >
                                    {loginMutation.isLoading ? 'Logging...' : 'Login Now'}
                                </Button>
                                {error && <Typography style={{ marginTop: 10 }} color="error">{error.message}</Typography>}
                                {loginMutation.isError && <Typography color="error">Login failed. Please try again.</Typography>}
                                <Typography style={{ textAlign: "center", marginTop: '10px' }} > New User? <Link to='/registration' style={{ color: "#4CAF50" }}>Register Now</Link></Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Container>
        </>
    )
}

export default Login